import {
  TABLE_MANAGEMENT_GROUP_SET_OUTLETS,
  TABLE_MANAGEMENT_GROUP_PAGE_REQUEST,
  TABLE_MANAGEMENT_GROUP_LIST_REQUEST,
  TABLE_MANAGEMENT_GROUP_SET_LIST,
  TABLE_MANAGEMENT_GROUP_SET_FILTERED_LIST,
  TABLE_MANAGEMENT_GROUP_SET_SUMMARY,
  TABLE_MANAGEMENT_GROUP_SET_DETAIL,
  TABLE_MANAGEMENT_GROUP_OPEN_RIGHT_COLUMN,
  TABLE_MANAGEMENT_GROUP_CLOSE_RIGHT_COLUMN,
  TABLE_MANAGEMENT_GROUP_UNSET_FILTER_STATE,
  TABLE_MANAGEMENT_GROUP_SET_FILTER_STATE,
  TABLE_MANAGEMENT_GROUP_SUMMARY_REQUEST,
  TABLE_MANAGEMENT_GROUP_SET_CURRENT_PAGE,
  TABLE_MANAGEMENT_GROUP_SET_TOTAL_PAGE,
  TABLE_MANAGEMENT_GROUP_ON_CHANGE_OUTLET_IDS,
  TABLE_MANAGEMENT_GROUP_IS_SUBMITTING_FORM,
  TABLE_MANAGEMENT_GROUP_ON_CLICK_ROW,
  TABLE_MANAGEMENT_GROUP_ON_CLICK_CANCEL,
  TABLE_MANAGEMENT_GROUP_SET_MUST_SCROLL_TOP,
  TABLE_MANAGEMENT_GROUP_ON_CLICK_CREATE_GROUP,
  TABLE_MANAGEMENT_GROUP_SUBMIT_FORM_CREATE,
  TABLE_MANAGEMENT_GROUP_SUBMIT_FORM_UPDATE,
  TABLE_MANAGEMENT_GROUP_SET_FILTER,
  TABLE_MANAGEMENT_GROUP_DUPLICATE_GROUP,
  TABLE_MANAGEMENT_GROUP_DUPLICATE_GROUP_CANCEL,
  TABLE_MANAGEMENT_GROUP_DELETE_REQUEST,
  TABLE_MANAGEMENT_GROUP_DELETE,
  TABLE_MANAGEMENT_GROUP_SET_DELETED,
  TABLE_MANAGEMENT_GROUP_SHOW_DELETE_MODAL,
  TABLE_MANAGEMENT_GROUP_HIDE_DELETE_MODAL,
  TABLE_MANAGEMENT_GROUP_CANCEL_DELETE,
  TABLE_MANAGEMENT_GROUP_SET_IS_SUBMITTING_FORM,
  TABLE_MANAGEMENT_MAP_PAGE_REQUEST,
  TABLE_MANAGEMENT_MAP_DROPDOWN_SELECT_GROUP,
  TABLE_MANAGEMENT_MAP_OPEN_ADD_TABLE,
  TABLE_MANAGEMENT_MAP_CLOSE_ADD_TABLE,
  TABLE_MANAGEMENT_MAP_SUBMIT_ADD_TABLE,
  TABLE_MANAGEMENT_MAP_OPEN_EDIT_MODAL,
  TABLE_MANAGEMENT_MAP_CLOSE_EDIT_MODAL,
  TABLE_MANAGEMENT_MAP_SUBMIT_EDIT_TABLE,
  TABLE_MANAGEMENT_MAP_SUBMIT_DELETE_TABLE,
  TABLE_MANAGEMENT_MAP_SET_TABLE,
  TABLE_MANAGEMENT_MAP_SET_TABLES,
  TABLE_MANAGEMENT_MAP_SET_ORIGINAL_TABLES,
  TABLE_MANAGEMENT_MAP_SUBMIT_SAVE_LAYOUT,
  TABLE_MANAGEMENT_MAP_SHOW_DELETE_MODAL,
  TABLE_MANAGEMENT_MAP_HIDE_DELETE_MODAL,
  TABLE_MANAGEMENT_MAP_UPDATE_SAVE_LAYOUT,
  TABLE_MANAGEMENT_REPORT_PAGE_REQUEST,
  TABLE_MANAGEMENT_REPORT_LIST_REQUEST,
  TABLE_MANAGEMENT_REPORT_SET_LIST,
  TABLE_MANAGEMENT_REPORT_SET_SUMMARY,
  TABLE_MANAGEMENT_REPORT_SET_DETAIL,
  TABLE_MANAGEMENT_REPORT_OPEN_RIGHT_COLUMN,
  TABLE_MANAGEMENT_REPORT_CLOSE_RIGHT_COLUMN,
  TABLE_MANAGEMENT_REPORT_SUMMARY_REQUEST,
  TABLE_MANAGEMENT_REPORT_SET_CURRENT_PAGE,
  TABLE_MANAGEMENT_REPORT_SET_TOTAL_PAGE,
  TABLE_MANAGEMENT_REPORT_ON_CHANGE_OUTLET_IDS,
  TABLE_MANAGEMENT_REPORT_ON_CLICK_ROW,
  TABLE_MANAGEMENT_REPORT_ON_CLICK_CANCEL,
  TABLE_MANAGEMENT_REPORT_CHANGE_STATUS,
  TABLE_MANAGEMENT_REPORT_CHANGE_DATE,
  TABLE_MANAGEMENT_REPORT_REQUEST,
  TABLE_MANAGEMENT_MAP_ON_CHANGE_OUTLET_IDS,
} from './constants';

export function setOutlets(outlets) {
  return { type: TABLE_MANAGEMENT_GROUP_SET_OUTLETS, payload: { outlets } };
}

export function groupPageRequest() {
  return { type: TABLE_MANAGEMENT_GROUP_PAGE_REQUEST };
}

export function groupsRequest(query, previousGroups) {
  return {
    type: TABLE_MANAGEMENT_GROUP_LIST_REQUEST,
    payload: { query, previousGroups },
  };
}

export function setGroups(groups) {
  return { type: TABLE_MANAGEMENT_GROUP_SET_LIST, payload: { groups } };
}

export function setFilteredGroups(filteredGroups) {
  return {
    type: TABLE_MANAGEMENT_GROUP_SET_FILTERED_LIST,
    payload: { filteredGroups },
  };
}

export function setGroupSummary(groupSummary) {
  return {
    type: TABLE_MANAGEMENT_GROUP_SET_SUMMARY,
    payload: { groupSummary },
  };
}

export function setGroupDetail(group) {
  return { type: TABLE_MANAGEMENT_GROUP_SET_DETAIL, payload: { group } };
}

export function openRightColumn() {
  return { type: TABLE_MANAGEMENT_GROUP_OPEN_RIGHT_COLUMN };
}

export function closeRightColumn() {
  return { type: TABLE_MANAGEMENT_GROUP_CLOSE_RIGHT_COLUMN };
}

export function unSetFilterState() {
  return { type: TABLE_MANAGEMENT_GROUP_UNSET_FILTER_STATE };
}

export function setFilterState(keyword) {
  return {
    type: TABLE_MANAGEMENT_GROUP_SET_FILTER_STATE,
    payload: { keyword },
  };
}

export function groupSummaryRequest(query) {
  return { type: TABLE_MANAGEMENT_GROUP_SUMMARY_REQUEST, payload: query };
}

export function setCurrentPage(currentPage) {
  return {
    type: TABLE_MANAGEMENT_GROUP_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
}

export function setTotalPage(totalPage) {
  return {
    type: TABLE_MANAGEMENT_GROUP_SET_TOTAL_PAGE,
    payload: { totalPage },
  };
}

export function onChangeOutletIds(outletIds) {
  return {
    type: TABLE_MANAGEMENT_GROUP_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds },
  };
}

export function onChangeOutletIdsMap(outletIds) {
  return {
    type: TABLE_MANAGEMENT_MAP_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds },
  };
}

export function isSubmittingForm(isSubmittingForm) {
  return {
    type: TABLE_MANAGEMENT_GROUP_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm },
  };
}

export function onClickCancel() {
  return { type: TABLE_MANAGEMENT_GROUP_ON_CLICK_CANCEL };
}

export function onClickRow(group) {
  return { type: TABLE_MANAGEMENT_GROUP_ON_CLICK_ROW, payload: { group } };
}

export function setMustScrollTop(mustScrollTop) {
  return {
    type: TABLE_MANAGEMENT_GROUP_SET_MUST_SCROLL_TOP,
    payload: { mustScrollTop },
  };
}

export function onClickCreateGroup() {
  return { type: TABLE_MANAGEMENT_GROUP_ON_CLICK_CREATE_GROUP };
}

export function submitFormCreate(values, previousGroups) {
  return {
    type: TABLE_MANAGEMENT_GROUP_SUBMIT_FORM_CREATE,
    payload: { values, previousGroups },
  };
}

export function submitFormUpdate(id, values, previousGroups) {
  return {
    type: TABLE_MANAGEMENT_GROUP_SUBMIT_FORM_UPDATE,
    payload: { id, values, previousGroups },
  };
}

export function deleteGroupRequest(deletedGroup) {
  return {
    type: TABLE_MANAGEMENT_GROUP_DELETE_REQUEST,
    payload: { deletedGroup },
  };
}

export function deleteGroup(id, previousGroups, groupDetail) {
  return {
    type: TABLE_MANAGEMENT_GROUP_DELETE,
    payload: { id, previousGroups, groupDetail },
  };
}

export function setDeletedGroup(deletedGroup) {
  return {
    type: TABLE_MANAGEMENT_GROUP_SET_DELETED,
    payload: { deletedGroup },
  };
}

export function showDeleteModal() {
  return { type: TABLE_MANAGEMENT_GROUP_SHOW_DELETE_MODAL };
}

export function hideDeleteModal() {
  return { type: TABLE_MANAGEMENT_GROUP_HIDE_DELETE_MODAL };
}

export function cancelDelete() {
  return { type: TABLE_MANAGEMENT_GROUP_CANCEL_DELETE };
}

export function setIsSubmittingForm(isSubmittingForm) {
  return {
    type: TABLE_MANAGEMENT_GROUP_SET_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm },
  };
}

export function setFilterTableGroup(search, groups, filteredGroups) {
  return {
    type: TABLE_MANAGEMENT_GROUP_SET_FILTER,
    payload: { search, groups, filteredGroups },
  };
}

export function duplicateGroup(group, groups) {
  return {
    type: TABLE_MANAGEMENT_GROUP_DUPLICATE_GROUP,
    payload: { group, groups },
  };
}

export function duplicateGroupCancel() {
  return { type: TABLE_MANAGEMENT_GROUP_DUPLICATE_GROUP_CANCEL };
}

// Map
export function mapPageRequest(params) {
  return { type: TABLE_MANAGEMENT_MAP_PAGE_REQUEST, payload: params };
}

export function dropDownSelectTableGroup(id) {
  return { type: TABLE_MANAGEMENT_MAP_DROPDOWN_SELECT_GROUP, payload: { id } };
}

export function setTables(tables) {
  return { type: TABLE_MANAGEMENT_MAP_SET_TABLES, payload: { tables } };
}

export function setOriginalTables(originalTables) {
  return {
    type: TABLE_MANAGEMENT_MAP_SET_ORIGINAL_TABLES,
    payload: { originalTables },
  };
}

export function setTable(table) {
  return { type: TABLE_MANAGEMENT_MAP_SET_TABLE, payload: { table } };
}

export function openAddTableModal() {
  return { type: TABLE_MANAGEMENT_MAP_OPEN_ADD_TABLE };
}

export function closeAddTableModal() {
  return { type: TABLE_MANAGEMENT_MAP_CLOSE_ADD_TABLE };
}

export function submitAddTable(table, tables, originalTables, groupDetail) {
  return {
    type: TABLE_MANAGEMENT_MAP_SUBMIT_ADD_TABLE,
    payload: { table, tables, originalTables, groupDetail },
  };
}

export function openEditTableModal() {
  return { type: TABLE_MANAGEMENT_MAP_OPEN_EDIT_MODAL };
}

export function closeEditTableModal() {
  return { type: TABLE_MANAGEMENT_MAP_CLOSE_EDIT_MODAL };
}

export function submitEditTable(table, tables, groupDetail, originalTables) {
  return {
    type: TABLE_MANAGEMENT_MAP_SUBMIT_EDIT_TABLE,
    payload: { table, tables, groupDetail, originalTables },
  };
}

export function submitDeleteTable(table, tables, groupDetail, originalTables) {
  return {
    type: TABLE_MANAGEMENT_MAP_SUBMIT_DELETE_TABLE,
    payload: { table, tables, groupDetail, originalTables },
  };
}

export function showTableMapDeleteModal() {
  return { type: TABLE_MANAGEMENT_MAP_SHOW_DELETE_MODAL };
}

export function hideTableMapDeleteModal() {
  return { type: TABLE_MANAGEMENT_MAP_HIDE_DELETE_MODAL };
}

export function updateSaveLayoutButton(tables, originalTables) {
  return {
    type: TABLE_MANAGEMENT_MAP_UPDATE_SAVE_LAYOUT,
    payload: { tables, originalTables },
  };
}

export function submitSaveLayout(tables, originalTables, groupDetail) {
  return {
    type: TABLE_MANAGEMENT_MAP_SUBMIT_SAVE_LAYOUT,
    payload: { tables, originalTables, groupDetail },
  };
}

// Report
export function reportPageRequest() {
  return { type: TABLE_MANAGEMENT_REPORT_PAGE_REQUEST };
}

export function reportsRequest(payload) {
  return { type: TABLE_MANAGEMENT_REPORT_LIST_REQUEST, payload };
}

export function setReports(reports) {
  return { type: TABLE_MANAGEMENT_REPORT_SET_LIST, payload: { reports } };
}

export function setReportSummary(reportSummary) {
  return {
    type: TABLE_MANAGEMENT_REPORT_SET_SUMMARY,
    payload: { reportSummary },
  };
}

export function setReportDetail(report) {
  return { type: TABLE_MANAGEMENT_REPORT_SET_DETAIL, payload: { report } };
}

export function reportSummaryRequest(query) {
  return { type: TABLE_MANAGEMENT_REPORT_SUMMARY_REQUEST, payload: query };
}

export function openReportsRightColumn() {
  return { type: TABLE_MANAGEMENT_REPORT_OPEN_RIGHT_COLUMN };
}

export function closeReportsRightColumn() {
  return { type: TABLE_MANAGEMENT_REPORT_CLOSE_RIGHT_COLUMN };
}

export function setReportsCurrentPage(currentPage) {
  return {
    type: TABLE_MANAGEMENT_REPORT_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
}

export function setReportsTotalPage(totalPage) {
  return {
    type: TABLE_MANAGEMENT_REPORT_SET_TOTAL_PAGE,
    payload: { totalPage },
  };
}

export function onReportsChangeOutletIds(payload) {
  return { type: TABLE_MANAGEMENT_REPORT_ON_CHANGE_OUTLET_IDS, payload };
}

export function onReportsClickRow(report) {
  return { type: TABLE_MANAGEMENT_REPORT_ON_CLICK_ROW, payload: { report } };
}

export function onReportsClickCancel() {
  return { type: TABLE_MANAGEMENT_REPORT_ON_CLICK_CANCEL };
}

export function changeReportStatus(payload) {
  return { type: TABLE_MANAGEMENT_REPORT_CHANGE_STATUS, payload };
}

export function changeReportDate(payload) {
  return { type: TABLE_MANAGEMENT_REPORT_CHANGE_DATE, payload };
}

export function reportRequest(query) {
  return { type: TABLE_MANAGEMENT_REPORT_REQUEST, payload: query };
}
